import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../../data/mock';

export const Header = ({ onBookNow }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setIsMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        isScrolled ? 'glass-strong py-3' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_outdoor-movie-date/artifacts/hmr7r529_TCE%20logo.webp"
            alt="The Curated Experience"
            className="h-10 md:h-12 w-auto"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="font-body text-[13px] text-ivory/40 hover:text-amber tracking-wide transition-colors duration-400"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Desktop CTA */}
        <button
          onClick={onBookNow}
          className="hidden lg:block font-body text-[13px] font-medium tracking-wider px-7 py-2.5 border border-amber/25 text-amber rounded-full hover:bg-amber/8 hover:border-amber/40 transition-all duration-400"
        >
          Reserve Now
        </button>

        {/* Mobile toggle */}
        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="lg:hidden text-ivory/60 hover:text-amber transition-colors"
          aria-label="Toggle menu"
        >
          {isMobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 glass-strong overflow-hidden transition-all duration-500 ${
          isMobileOpen ? 'max-h-[400px] py-8' : 'max-h-0 py-0'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="font-body text-[13px] text-ivory/50 hover:text-amber transition-colors text-left tracking-wide"
            >
              {link.label}
            </button>
          ))}
          <div className="pt-3 mt-1 border-t border-amber/8">
            <button
              onClick={() => { setIsMobileOpen(false); onBookNow(); }}
              className="w-full font-body text-[13px] font-medium tracking-wider px-7 py-2.5 border border-amber/25 text-amber rounded-full hover:bg-amber/8 transition-all"
            >
              Reserve Now
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
